import { ComboField } from '@components/Fields/ComboField';
import { StringField } from '@components/Fields/StringField';
import { TelefoneField } from '@components/Fields/TelefoneField';
import { FixedFilterPanel } from '@components/FixedFilterPanel';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IFilter } from '@hooks/useFilter';
import { IComboEmpresa } from '@model/Empresa';
import { IComboOperadora } from '@model/Operadora';
import { IRelatorioConferenciaChipFilter } from '@services/RelatorioService';
import React from 'react';

export type ConferenciaChipFilterProps = {
    filter: IFilter<IRelatorioConferenciaChipFilter>
    isLoading: boolean
    empresaCombo: IComboEmpresa
    operadoraCombo: IComboOperadora
}

export function ConferenciaChipFilter ({ filter, isLoading, empresaCombo, operadoraCombo }: ConferenciaChipFilterProps) {
    const handleReset = React.useCallback(() => {
        filter.resetFilter();
    }, [filter]);

    return (
        <FixedFilterPanel
            onSearch={filter.handleFilterRequest}
            onClear={handleReset}
            disabled={isLoading}
        >
            <HorizontalGrid spacing={1}>
                <GridItem xs={1}>
                    <StringField
                        field={filter.fields.ddd}
                        label="DDD"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        inputProps={{
                            maxLength: 2
                        }}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <TelefoneField
                        maskType="cel"
                        field={filter.fields.numeroSemMascara}
                        label="Telefone"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.empresaId}
                        label="Empresa"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        {
                            empresaCombo.createOptions()
                        }
                    </ComboField>
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.operadoraId}
                        label="Operadora"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        {
                            operadoraCombo.createOptions()
                        }
                    </ComboField>
                </GridItem>
            </HorizontalGrid>
        </FixedFilterPanel>
    )
}